import React, { ReactElement, useState } from 'react';
import { Carousel } from 'primereact/carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import { uploadedImageDir } from '../../utils/configs';
import './Carousel.scss';

interface ImageCarouselProps {
  images: string[];
}

const ImageCarousel = (props: ImageCarouselProps): ReactElement => {
  const { images } = props;
  const [page, setPage] = useState(0);
  const productTemplate = (image) => (
    <img
      className="carousel-item"
      src={`${uploadedImageDir}/${image}`}
      alt={`${uploadedImageDir}/${image}`.split('/').pop()}
    />
  );
  const setPageManually = (nextPage) => {
    if (nextPage >= 0 && nextPage < images.length) setPage(nextPage);
  };
  return (
    <div className="carousel-main">
      <button
        className="carousel-page-button left"
        type="button"
        onClick={() => setPageManually(page - 1)}
      >
        <FontAwesomeIcon
          className="carousel-page-icon"
          icon={faChevronLeft}
          size="2x"
        />
      </button>
      <Carousel
        page={page}
        onPageChange={(e) => setPage(e.page)}
        value={images}
        itemTemplate={productTemplate}
      />
      <button
        className="carousel-page-button right"
        type="button"
        onClick={() => setPageManually(page + 1)}
      >
        <FontAwesomeIcon
          className="carousel-page-icon"
          icon={faChevronRight}
          size="2x"
        />
      </button>
    </div>
  );
};

export default ImageCarousel;
